// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bdeafd9b","867":"0700e2bc"}[chunkId] + ".chunk.js";
};